import Ajax from "@/api/ajax";
export default{
    checkEzgopayStatus(params){
        return Ajax.post("/Home/check_pay_status", params);
    }

}